
<p-card>
    <p-table [value]="isolationlist" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['instrument']" [columns]="cols" stateStorage="local" stateKey="isolationlist-state">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="instrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Instrument
                        <p-sortIcon field="instrument"></p-sortIcon>
                        <p-columnFilter type="text" field="instrument" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="startDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Start Date
                        <p-sortIcon field="startDate"></p-sortIcon>
                        <p-columnFilter type="date" field="startDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="endDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        End Date
                        <p-sortIcon field="endDate"></p-sortIcon>
                        <p-columnFilter type="date" field="endDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="isoIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Incident
                        <p-sortIcon field="isoIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="isoIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="isoIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Incident Date
                        <p-sortIcon field="isoIncidentDate"></p-sortIcon>
                        <p-columnFilter type="text" field="isoIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="isoService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Service
                        <p-sortIcon field="isoService"></p-sortIcon>
                        <p-columnFilter type="text" field="isoService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="isoServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Service Date
                        <p-sortIcon field="isoServiceDate"></p-sortIcon>
                        <p-columnFilter type="text" field="isoServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-isolation>
            <tr (click)="rowClick(isolation)">
                <td>{{isolation.instrument}}</td>
                <td>{{isolation.startDate | date:'short'}}</td>
                <td>{{isolation.endDate | date:'short'}}</td>
                <td>{{isolation.isoIncident}}</td>
                <td>{{isolation.isoIncidentDate | date:'short'}}</td>
                <td>{{isolation.isoService}}</td>
                <td>{{isolation.isoServiceDate | date:'short'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>